import React from 'react'

export const RightArrowSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M11.6667 11L10.7167 10.0667L12.1167 8.66667H2V7.33333H12.1167L10.7333 5.93333L11.6833 5L14.6667 8L11.6667 11Z" fill="black" fill-opacity="0.45" />
        </svg>
    )
}